import { quizData as pythonQuizData } from './quizData';
import { codingQuizData as pythonCodingQuizData } from './codingQuizData';
import { javascriptQuizData } from './javascriptQuizData';
import { reactQuizData } from './reactQuizData';
import { javascriptCodingQuizData } from './javascriptCodingQuizData';
import { reactCodingQuizData } from './reactCodingQuizData';
import { htmlQuizData } from './htmlQuizData';
import { cssQuizData } from './cssQuizData';
import { htmlCodingQuizData } from './htmlCodingQuizData';
import { cssCodingQuizData } from './cssCodingQuizData';

export const allQuizData = {
    python: pythonQuizData,
    javascript: javascriptQuizData,
    react: reactQuizData,
    html: htmlQuizData,
    css: cssQuizData,
};

export const allCodingQuizData = {
    python: pythonCodingQuizData,
    javascript: javascriptCodingQuizData,
    react: reactCodingQuizData,
    html: htmlCodingQuizData,
    css: cssCodingQuizData,
};
